export const DeliveryMethods = {
    delivery: 'delivery',
    pickup: 'pickup'
};